import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourceDetailTeamWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;

  ${BREAKPOINTS.large_tablet_landscape} {
    grid-template-columns: repeat(4, 1fr);
  }

  ${BREAKPOINTS.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ResourceDetailTeamTitleContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;
`;

export const ResourceDetailTeamPersonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 16px;

  cursor: pointer;
`;

export const ResourceDetailTeamPersonInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ResourceDetailTeamPersonName = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;

  color: var(--color-text);
`;

export const ResourceDetailTeamPersonRole = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  text-align: center;

  color: rgba(23, 28, 51, 0.5);
`;

export const ResourceDetailTeamShowMoreCircle = styled.div`
  width: 40px;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 100%;
  border: 2px solid var(--color-data-people-foreground);
  background: var(--color-data-people-background-secondary);
`;

export const ResourceDetailTeamShowMoreText = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  text-align: center;

  color: var(--color-text);
`;

export const ResourceDetailTeamMessageAllButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  padding: 8px 26px;

  border: 2px solid var(--color-primary);
  border-radius: 100px;

  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 194, 41, 0.15);
  }
`;

export const ResourceDetailTeamMessageAllButtonText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: var(--color-text);
`;
